import { render, staticRenderFns } from "./BoInfoCat.vue?vue&type=template&id=0c493d5f&"
import script from "./BoInfoCat.vue?vue&type=script&lang=js&"
export * from "./BoInfoCat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports